import styled from 'styled-components';

export const StyledBox = styled.div`
  display: flex;
`;

export const StyledBoxColumn = styled(StyledBox).attrs(props => ({
  'data-testid': props.testId
}))`
  flex-direction: column;
`;

export const StyledBoxRow = styled(StyledBox).attrs(props => ({
  'data-testid': props.testId
}))`
  flex-direction: row;
`;

export const StyledBoxCentered = styled(StyledBox).attrs(props => ({
  'data-testid': props.testId
}))`
  justify-content: center;
  align-items: center;
`;
